import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import Card from '../Card';
import { ProjectCardProps } from '../Card/types';

import './style.scss';

const ProjectCard: React.FC<ProjectCardProps> = (props) => {
  const {
    title,
    status,
    type,
    image,
    link,
    className,
  } = props;

  const { t } = useTranslation();

  const classNames = c('ProjectCard', 'u-focus-ring--within', 'u-link-box--before', className);

  return (
    <Card className={classNames}>
      <Card.Content>
        <Card.Title title={title} />

        <Card.Subtitle subtitle={status} />
        <Card.Subtitle subtitle={type.join(', ')} />
      </Card.Content>

      <Card.Image image={image} />

      <CoreLink
        className="ProjectCard__link"
        to={link}
        title={t('components.project_card.link')}
      />
    </Card>
  );
};

export default ProjectCard;
